import React from 'react';
import clsx from 'clsx';
import { Form, Modal } from 'semantic-ui-react';
import { firstError } from '@/utils/errors';
import HoverActionHeader from '@/components/HoverActionHeader';
import { states } from '@/constants/lifecycle';
import NoRows from '@/components/table/NoRows';
import ErrorPlaceHolder from '@/components/errors/ErrorPlaceHolder';
import { hasMinimumLength } from '@/utils/resultsHelper';
import TaskRequestFormInfo from './TaskRequestFormInfo';
import TaskTabPanes from './TaskTabPanes';
import Selectors from '../hooks/selectors';

const TaskRequestDialogContent = () => {
  const {
    assignee, groups, readErrors, readStatus, workflow,
  } = Selectors.useTaskRequestDialogContent();

  return (
    <>
      {(readStatus === states.SUCCESS && (assignee || groups.length > 0)) && (
      <TaskRequestFormInfo assignee={assignee} groups={groups} />
      )}
      <Modal.Content scrolling className={clsx('pt-10')}>
        <Form autoComplete="off" className="h-100p flex flex-column min-h-160">
          <div className="mt-0 mb-0">
            {hasMinimumLength(workflow) && (
              <HoverActionHeader className="aridhia-request-list-header" value={workflow} />
            )}
            {readStatus === states.ERROR && (<ErrorPlaceHolder error={firstError(readErrors)} />)}
            {readStatus !== states.ERROR && (
              <>
                {readStatus === states.SUCCESS && (<TaskTabPanes />)}
                {readStatus === states.PENDING && (<NoRows icon="tick" entity="task" className="min-h-35" loading />)}
              </>
            )}
          </div>
        </Form>
      </Modal.Content>
    </>
  );
};

export default TaskRequestDialogContent;
